import React from 'react';
import { Link } from 'react-router-dom';
import './CareerExplorerCTA.css';

const CareerExplorerCTA = () => {
  return (
    <section className="section career-explorer-section">
      <div className="container">
        <div className="career-explorer-content">
          <div className="career-explorer-text">
            <span className="career-explorer-badge">Free Tool</span>
            <h2 className="career-explorer-title">
              Not sure what to do <span className="title-highlight">after 12th?</span>
            </h2>
            <p className="career-explorer-subtitle">
              Explore 270+ courses and careers mapped to your exact subject combination, or take a 5-minute personality quiz to discover what career fits you best.
            </p>
            <div className="career-explorer-features">
              <div className="feature-item">
                <div className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                  </svg>
                </div>
                <div>
                  <strong>Career Pathways Explorer</strong>
                  <span>27 subject combos with courses, salaries & colleges</span>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </div>
                <div>
                  <strong>Career Personality Quiz</strong>
                  <span>12 questions to match you with your ideal career type</span>
                </div>
              </div>
            </div>
            <div className="career-explorer-cta-buttons">
              <Link to="/careerexplorer" className="btn btn-primary">Try Career Explorer</Link>
            </div>
          </div>
          <div className="career-explorer-visual">
            <div className="visual-card visual-card-1">
              <div className="visual-card-icon">🔬</div>
              <div className="visual-card-label">Science</div>
              <div className="visual-card-sub">PCM, PCB, PCMB</div>
            </div>
            <div className="visual-card visual-card-2">
              <div className="visual-card-icon">📊</div>
              <div className="visual-card-label">Commerce</div>
              <div className="visual-card-sub">SECA, MECA, BECA</div>
            </div>
            <div className="visual-card visual-card-3">
              <div className="visual-card-icon">🎭</div>
              <div className="visual-card-label">Arts</div>
              <div className="visual-card-sub">HEPS, HEPP, PSHE</div>
            </div>
            <div className="visual-card visual-card-4">
              <div className="visual-card-icon">🧠</div>
              <div className="visual-card-label">Personality Quiz</div>
              <div className="visual-card-sub">5 min, 6 career types</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerExplorerCTA;
